import { render, staticRenderFns } from "./PartialInfoMajorCategory.vue?vue&type=template&id=4b3a6852&"
import script from "./PartialInfoMajorCategory.vue?vue&type=script&lang=ts&"
export * from "./PartialInfoMajorCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports